import { Antrag, EinreichungStep } from '@ebeihilfe/einreichung-old';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { ComponentCanDeactivate, ConfigSettingsService } from '@ebeihilfe/core';
import { ModalService } from '@ebeihilfe/web-logic';
import { TranslateService } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-einreichung',
  templateUrl: 'portal-einreichung.component.html',
  styleUrls: ['./portal-einreichung.component.scss'],
  standalone: false,
})
export class PortalEinreichungComponent implements OnInit, ComponentCanDeactivate {
  private readonly configService = inject(ConfigSettingsService);
  private readonly modalService = inject(ModalService);
  private readonly translate = inject(TranslateService);

  public currentStep: EinreichungStep;
  public maximumAntragSizeInMb: number;
  public maximumFileSizeInMb: number;
  public showSpinner = false;
  private antrag: Antrag;

  @HostListener('window:beforeunload', ['$event']) public unload(): void {
    // navigating to external sites can't be prevented from within angular
    // just need some stub function to get called when user clicks some link
  }

  public antragChangedEmitter(antrag: Antrag): void {
    this.antrag = antrag;
  }

  public canDeactivate(): Promise<boolean> {
    // antrag completed, just leave
    if (this.antrag?.isComplete) {
      return Promise.resolve(true);
    }

    // antrag has no data, just leave
    if (!this.antrag?.hasAntragsMetadata() && !this.antrag?.hasSeiten()) {
      return Promise.resolve(true);
    }

    return this.modalService.openConfirmationModal({
      content: this.translate.instant('new_antrag.text.discarding_all_data'),
    });
  }

  public fromEinreichungsStepEmitter(currentEinreichungsStep: EinreichungStep): void {
    this.currentStep = currentEinreichungsStep;
  }

  public hasUiEmitter(hasUi: boolean): void {
    this.showSpinner = !hasUi;
  }

  public ngOnInit(): void {
    const constants = this.configService.appSettings.constants;
    this.maximumFileSizeInMb = constants.maximumFileSizeInMb;
    this.maximumAntragSizeInMb = constants.maximumAntragSizeInMb;
  }
}
